'use client';

import { faUserTie } from '@fortawesome/pro-solid-svg-icons';
import { hasContent } from 'src/utils/hasContent/hasContent';
import InfoUnavailable from './InfoUnavailable';
import { useProfile } from 'src/context/providers/ProfileProvider';
import { Card, Box, ProfileCardHeader, Typography } from 'src/components/PulseUI';

const ProfileExecTeam = () => {
  const { entityDetails } = useProfile();
  const team = entityDetails?.board_members || [];

  return (
    <Card className="p-6">
      <ProfileCardHeader icon={faUserTie} title="Executive Team" />
      <Box className="flex flex-col gap-4">
        {hasContent(team) ? (
          team.map((member: any, i: number) => (
            <Box key={`${member.title}-${i}`} className="flex flex-col">
              <Typography variant="body2" color="tertiary">
                {member.title}
              </Typography>
              <Typography variant="body2" color="primary" bold>
                {member.name || 'Not available'}
              </Typography>
            </Box>
          ))
        ) : (
          <InfoUnavailable />
        )}
      </Box>
    </Card>
  );
};

export default ProfileExecTeam;
